/* TODO: this code was copy/pasted from space.js & modified - needs a refactor. */
import { DateTime } from "luxon"
import flatpickr from "flatpickr"
import { marked } from "marked"
import DOMPurify from "dompurify"
import Swal from "sweetalert2"
import * as util from "./util"
import * as utillogin from "./utillogin"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    util.amplitudeInit(instance, "Change Booking Viewed")
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()
    var spacesJson

    var fp // flatpickr
    var date
    var availableTimes
    var startTime
    var startTimeOnNextDay = false
    var endTime
    var endTimeOnNextDay = false
    const TIME_NONE = 0
    const TIME_START = 1
    var timeStatus = TIME_NONE

    // Used if user checks "Set custom times"
    var customDate
    var customStartTime
    var customEndTime

    var checkoutData = [] // Acuity forms and addons
    var availableAddons = []
    var selectedAddons = []
    var checkoutNumHours
    var checkoutTotalPrice

    var slug
    var availability
    var session
    var changesToSend
    var changesToDisplay

    var payLaterDateTime

    async function initClerk() {
      if (await isDashboardPage(false)) {
        // Redirect if not already logged in
        await utillogin.getClerkToken()
        utillogin.displayAdminNavItems()
      }

      await getSessionAndAvailabilityData()
      updateSpaces()
    }

    async function isDashboardPage(adminRequired) {
      if (window.location.pathname != "/change-session") {
        return false
      }
      if (adminRequired) {
        return await utillogin.getClerkUserIsAdmin()
      }
      return true
    }

    async function getSessionAndAvailabilityData() {
      try {
        const data = await util.api
          .get(`get-session-and-availability?id=${searchParams.get("id")}`)
          .json()
        postAvailabilityLoad(data)
      } catch (error) {
        util.logToSentry(error)
        util.logAmplitudeEvent(
          "Unknown Error Retrieving Space Availability (Change Booking)"
        )
        showError(
          "There was an error retrieving availability. Please refresh and if the problem persists email help@sharesy.com."
        )
      }
    }

    function showError(message) {
      document.getElementById("preloader-background").classList.add("hide")
      document.getElementById("error-section").style.display = "flex"
      if (message) {
        document.getElementById("error-message").innerText = message
      }
      document.getElementById("main-section").classList.add("hide")
    }

    function postAvailabilityLoad(data) {
      availability = data.availability
      spacesJson = [availability]

      session = data.session
      slug = session.space_slug

      let spaceSelect = document.getElementById("space")
      if (spaceSelect.options.length === 0) {
        let option = document.createElement("option")
        option.value = slug
        option.innerText = session.space_name
        spaceSelect.appendChild(option)
      }
      document.getElementById("basket-space-name").innerText =
        session.space_name

      let startDateTime = DateTime.fromISO(session.event_start_utc).setZone(
        util.TIMEZONE
      )
      startTime = startDateTime.toFormat("HH:mm")
      date = startDateTime.toFormat("yyyy-MM-dd")
      endTime = DateTime.fromISO(session.event_end_utc)
        .setZone(util.TIMEZONE)
        .toFormat("HH:mm")
      if (endTime < startTime) {
        endTimeOnNextDay = true
      }

      prepareBookingSection()
    }

    async function updateSpaces() {
      let endpoint
      if (await isDashboardPage(true)) {
        endpoint = `get-spaces-token?token=${await utillogin.getClerkToken()}`
      } else {
        endpoint = `get-spaces-in-venue?id=${searchParams.get("id")}`
      }
      let spaceData
      try {
        spaceData = await util.api.get(endpoint).json()
      } catch (error) {
        util.logToSentry(error)
        util.logAmplitudeEvent(
          "Unknown Error Retrieving Spaces (Change Booking)"
        )
      }
      let spaceSelect = document.getElementById("space")
      while (spaceSelect.options.length > 0) {
        spaceSelect.remove(0)
      }
      spaceData.forEach(function (space) {
        let option = document.createElement("option")
        option.value = space.slug
        option.innerText = space.name
        spaceSelect.appendChild(option)
        if (space.slug == slug) {
          option.selected = true
        }
      })
      spaceSelect.addEventListener("change", async function (e) {
        slug = spaceSelect.value
        try {
          if (slug == session.space_slug) {
            // We want to see availability excluding the original session
            spacesJson = [availability]
          } else {
            spacesJson = await util.api
              .get(
                `get-space-availability-combined?slug=${slug}&newsystem=true`
              )
              .json()
          }
        } catch (error) {
          util.logToSentry(error)
          util.logAmplitudeEvent(
            "Unknown Error Retrieving Space Availability (Change Booking)"
          )
        }
        let dateArray = spacesJson[0].dates.map((s) => s["start_date"])
        fp.set("enable", dateArray)
        setTimeAvailability()
        await onTimesChange(true)
        document.getElementById("basket-space-name").innerText =
          spaceSelect.options[spaceSelect.selectedIndex].text
      })
    }

    /**
     * Set up the booking section (date and time pickers etc)
     */
    async function prepareBookingSection() {
      // Check if flatpickr already exists - if so assume this has been run before
      if (!fp) {
        // Flatpickr calendar
        let dateArray = spacesJson[0].dates.map((s) => s["start_date"])
        fp = flatpickr(".flatpickr", {
          enableTime: false,
          wrap: true,
          disableMobile: "true",
          monthSelectorType: "static",
          locale: {
            firstDayOfWeek: 1, // start week on Monday
          },
          enable: dateArray,
          onChange: flatpickrDateChange,
        })

        document
          .getElementById("start-time-select")
          .addEventListener("click", function (e) {
            if (date) {
              displayTimeModal(true)
            } else {
              fp.open()
            }
            const eventProperties = {
              "Selected Date": document.querySelector(".text-date-input-space")
                .value,
            }
            util.logAmplitudeEvent(
              "Open Start Time (Change Booking)",
              eventProperties
            )
          })
        document
          .getElementById("end-time-select")
          .addEventListener("click", function (e) {
            if (date) {
              if (
                !document
                  .getElementById("end-time-select")
                  .classList.contains("highlighted")
              ) {
                displayTimeModal(false)
              }
            } else {
              fp.open()
            }
            util.logAmplitudeEvent("Open End Time (Change Booking)")
          })

        // Add listeners for Amplitude
        document
          .getElementById("date-select")
          .addEventListener("click", function (e) {
            util.logAmplitudeEvent("Open Choose Date (Change Booking)")
          })

        // Add listeners to the time modal buttons.
        let elem = document.getElementById("time-modal-clear")
        elem.addEventListener("click", function () {
          timeClear()
          try {
            const eventProperties = {
              "Selected Date": document.querySelector(".text-date-input-space")
                .value,
              "Start Time": startTime,
              "End Time": endTime,
            }
            if (startTimeOnNextDay) {
              eventProperties["Start Time On Next Day"] = true
            }
            if (endTimeOnNextDay) {
              eventProperties["End Time On Next Day"] = true
            }
            util.logAmplitudeEvent(
              "Clear Times (Change Booking)",
              eventProperties
            )
          } catch (err) {}
        })
        elem = document.getElementById("time-modal-close")
        elem.addEventListener("click", timeClose)

        fp.setDate(date)
        let fpResult = await flatpickrDateChange(
          fp.selectedDates,
          undefined,
          undefined,
          false
        )
        if (!fpResult) {
          // Needed for past bookings
          setDateText()
          await onTimesChange(true)
        }

        try {
          let targetNode =
            document.getElementsByClassName("flatpickr-calendar")[0]
          let flatpickrObserver = new MutationObserver(function () {
            if (targetNode.classList.contains("open")) {
              document
                .getElementById("date-select")
                .classList.add("highlighted")
            } else {
              document
                .getElementById("date-select")
                .classList.remove("highlighted")
            }
          })
          flatpickrObserver.observe(targetNode, {
            attributes: true,
            childList: true,
          })
        } catch (err) {
          util.logToSentry(err)
        }

        displayCheckout()
      }

      // Without this, if you select a date then switch away from the browser, when you click back on the page Flatpickr opens again.
      try {
        document.getElementsByClassName("flatpickr-input")[0].addEventListener(
          "focus",
          function (e) {
            e.currentTarget.blur()
          },
          true
        )
        document.getElementById("date-select").addEventListener(
          "focus",
          function (e) {
            e.currentTarget.blur()
          },
          true
        )
      } catch (err) {
        util.logToSentry(err)
      }
    }

    // Fired each time a date is selected in the date picker
    async function flatpickrDateChange(
      selectedDates,
      dateStr,
      instance,
      userGenerated = true
    ) {
      if (selectedDates.length > 0) {
        // Need to remove timezone offset before splitting ISO string
        // See: https://stackoverflow.com/a/50130338
        let d = new Date(
          selectedDates[0].getTime() -
            selectedDates[0].getTimezoneOffset() * 60000
        )
        date = d.toISOString().split("T")[0]

        setDateText()
        setTimeAvailability()

        if (startTime && endTime) {
          await onTimesChange(true)
        }
        return true
      }
      return false
    }

    function setDateText() {
      let inputTextDate = document.getElementById("input-text-date")
      inputTextDate.innerText = new Date(date).toLocaleDateString("en-GB", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      })
      inputTextDate.classList.add("completed")
      updateCancelBy()
    }

    function updateCancelBy() {
      // For delayed payment bookings, by default take payment tomorrow
      payLaterDateTime = DateTime.now().plus({ days: 1 })
      let eventDate = DateTime.fromISO(date + "T00:00", { zone: util.TIMEZONE })
      if (startTime) {
        eventDate = DateTime.fromISO(date + "T" + startTime, {
          zone: util.TIMEZONE,
        })
      }
      let eventCancelBy = null
      let purchaseCancelBy = DateTime.now().plus({ days: 2 })
      if (eventDate.minus({ days: 14 }) > DateTime.now()) {
        eventCancelBy = eventDate.minus({ days: 14 })
      }
      if (eventCancelBy && eventCancelBy.ts >= purchaseCancelBy.ts) {
        let cancelBy = eventCancelBy.toFormat("ccc dd MMM")
        if (startTime) {
          cancelBy = eventCancelBy.toFormat("t 'on' ccc dd MMM")
        }
        if (eventCancelBy.year > DateTime.now().year) {
          cancelBy += " " + eventCancelBy.toFormat("yyyy")
        }
        document.getElementById("checkout-cancel-by").innerText =
          "Free cancellation until " + cancelBy
        document
          .getElementById("checkout-cancel-section")
          .classList.remove("hide")

        if (eventCancelBy.ts >= DateTime.now().plus({ days: 7 }).ts) {
          // Take payment later if there are at least 5 days before they have
          // to pay.
          payLaterDateTime = eventCancelBy.minus({ days: 3 })
        }
      } else {
        document.getElementById("checkout-cancel-section").classList.add("hide")
      }
    }

    function setTimeAvailability() {
      // Diable all times by default
      timeClear(true)
      const timeButtons = document.getElementsByClassName("time-button")
      for (const tb of timeButtons) {
        tb.removeEventListener("click", timeButtonClick)
        tb.classList.add("no-avail")
      }

      let validTimeButtons = new Array()
      let noAvailStartTimeButtons = new Array()

      // Loop over times for the date
      let currDateTimes = spacesJson[0].dates.filter(
        (d) => d.start_date === date
      )
      if (!currDateTimes || currDateTimes.length === 0) {
        return
      }
      availableTimes = currDateTimes[0].times
      for (const t of availableTimes) {
        // Loop over time buttons
        for (const tb of timeButtons) {
          let btnTime = DateTime.fromISO(date + "T" + tb.innerText, {
            zone: util.TIMEZONE,
          })
          if (tb.dataset.addDay === "1") {
            btnTime = btnTime.plus({ days: 1 })
          }
          if (btnTime.ts >= t.start_time_utc && btnTime.ts <= t.end_time_utc) {
            tb.classList.remove("no-avail")
            if (btnTime.plus({ hours: t.min_at_hours }).ts > t.end_time_utc) {
              // Time is enabled but can't be selected as a start time
              noAvailStartTimeButtons.push(tb)
            } else {
              // Time is fully enabled
              validTimeButtons.push(tb)
            }
          }
        }
      }
      for (const tb of noAvailStartTimeButtons) {
        // Could have used another reason to explain e.g. 'Available but not a valid start time'
        util.addButtonClassAndTooltip(
          tb,
          "no-avail-start-time",
          "Choose an earlier start time"
        )
      }
      for (const tb of validTimeButtons) {
        util.removeButtonClassAndTooltip(tb, "no-avail-start-time")
        tb.addEventListener("click", timeButtonClick)
      }
    }

    function timeButtonClick(e) {
      let selectedButtons = document.getElementsByClassName(
        "time-button selected"
      )
      if (timeStatus === TIME_NONE) {
        timeStatus = TIME_START
        e.currentTarget.classList.add("selected")
        startTime = selectedButtons[0].innerText
        if (selectedButtons[0].dataset.addDay === "1") {
          startTimeOnNextDay = true
        } else {
          startTimeOnNextDay = false
        }

        document.getElementById("time-modal-header").innerText =
          "Choose an end time"
        document.getElementById("time-modal-clear").style.display = "block"

        document
          .getElementById("start-time-select")
          .classList.remove("highlighted")
        document.getElementById("end-time-select").classList.add("highlighted")
        let inputTextStartTime = document.getElementById(
          "input-text-start-time"
        )
        inputTextStartTime.innerText = startTime
        inputTextStartTime.classList.add("completed")
        // In case an end time was already selected
        let inputTextEndTime = document.getElementById("input-text-end-time")
        inputTextEndTime.innerText = "Choose time"
        inputTextEndTime.classList.remove("completed")

        let startBtnTime = DateTime.fromISO(date + "T" + startTime, {
          zone: util.TIMEZONE,
        })
        if (startTimeOnNextDay) {
          startBtnTime = startBtnTime.plus({ days: 1 })
        }
        let validTimes = availableTimes.filter(
          (t) =>
            startBtnTime.ts >= t.start_time_utc &&
            startBtnTime.plus({ hours: t.min_at_hours }).ts <= t.end_time_utc
        )

        let validTimeButtons = new Array()
        let noAvailEndTimeButtons = new Array()
        const timeButtons = document.getElementsByClassName("time-button")
        for (const tb of timeButtons) {
          util.removeButtonClassAndTooltip(tb, "no-avail-start-time")
          if (
            (startTimeOnNextDay && tb.dataset.addDay !== "1") ||
            (startTimeOnNextDay &&
              tb.dataset.addDay === "1" &&
              tb.innerText < startTime) ||
            (!startTimeOnNextDay &&
              tb.dataset.addDay !== "1" &&
              tb.innerText < startTime)
          ) {
            tb.classList.add("disabled")
          } else if (
            tb.innerText !== startTime &&
            !tb.classList.contains("no-avail")
          ) {
            let btnTime = DateTime.fromISO(date + "T" + tb.innerText, {
              zone: util.TIMEZONE,
            })
            if (tb.dataset.addDay === "1") {
              btnTime = btnTime.plus({ days: 1 })
            }
            for (const l of validTimes) {
              /* Only enable the end times that:
                    - Are at least selected start time + min appt type length
                    - Are no higher than (selected start time + max appt type
                      length) or end time range. Note: enquiry-only spaces only
                      need the minimum time-slot set up e.g. 3 hr, not all
                      time-slots e.g. 3, 4, ... 13 hrs.
              */
              let endTimeOrMaxDuration = l.end_time_utc
              if (l.max_at_hours) {
                endTimeOrMaxDuration = Math.min(
                  startBtnTime.plus({ hours: l.max_at_hours }).ts,
                  l.end_time_utc
                )
              }
              if (
                btnTime.ts >= startBtnTime.plus({ hours: l.min_at_hours }).ts &&
                btnTime.ts <= endTimeOrMaxDuration
              ) {
                validTimeButtons.push(tb)
              } else {
                noAvailEndTimeButtons.push(tb)
              }
            }
          }
        }

        for (const tb of noAvailEndTimeButtons) {
          let btnTime = DateTime.fromISO(date + "T" + tb.innerText, {
            zone: util.TIMEZONE,
          })
          if (tb.dataset.addDay === "1") {
            btnTime = btnTime.plus({ days: 1 })
          }
          let hoursDiff = btnTime.diff(startBtnTime, "hours").toObject().hours
          let minHours = Math.min.apply(
            Math,
            validTimes.map(function (o) {
              return o.min_at_hours
            })
          )
          let reason = ""
          if (hoursDiff < minHours) {
            reason =
              "The minimum duration is " +
              util.roundToMaxDp(minHours, 1) +
              " hours"
          }
          util.addButtonClassAndTooltip(tb, "no-avail-end-time", reason)
        }
        for (const tb of validTimeButtons) {
          util.removeButtonClassAndTooltip(tb, "no-avail-end-time")
          tb.addEventListener("click", timeButtonClick)
          tb.addEventListener("mouseover", mouseoverSelectOtherTimes)
          tb.addEventListener("mouseout", mouseoutSelectOtherTimes)
        }

        document.querySelector(".time-modal").style.display = "none"
        setTimeout(function () {
          document.querySelector(".time-modal").style.display = "flex"
        }, 300)

        try {
          const eventProperties = {
            "Selected Date": document.querySelector(".text-date-input-space")
              .value,
            "Start Time": startTime,
          }
          if (startTimeOnNextDay) {
            eventProperties["Start Time On Next Day"] = true
          }
          util.logAmplitudeEvent(
            "Select Start Time (Change Booking)",
            eventProperties
          )
        } catch (err) {}
      } else if (timeStatus === TIME_START) {
        let tempEndTime = e.currentTarget.innerText
        let tempEndTimeOnNextDay = false
        if (e.currentTarget.dataset.addDay === "1") {
          tempEndTimeOnNextDay = true
        }
        if (
          !e.currentTarget.classList.contains("no-avail-end-time") &&
          ((tempEndTimeOnNextDay && !startTimeOnNextDay) ||
            (tempEndTimeOnNextDay === startTimeOnNextDay &&
              tempEndTime > startTime))
        ) {
          endTime = tempEndTime
          endTimeOnNextDay = tempEndTimeOnNextDay

          let inputTextEndTime = document.getElementById("input-text-end-time")
          inputTextEndTime.innerText = endTime
          inputTextEndTime.classList.add("completed")

          document.querySelector(".time-modal").style.display = "none"
          try {
            document
              .getElementById("start-time-select")
              .classList.remove("highlighted")
          } catch (err) {}
          try {
            document
              .getElementById("end-time-select")
              .classList.remove("highlighted")
          } catch (err) {}

          try {
            const eventProperties = {
              "Selected Date": document.querySelector(".text-date-input-space")
                .value,
              "Start Time": startTime,
              "End Time": endTime,
            }
            if (startTimeOnNextDay) {
              eventProperties["Start Time On Next Day"] = true
            }
            if (endTimeOnNextDay) {
              eventProperties["End Time On Next Day"] = true
            }
            util.logAmplitudeEvent(
              "Select End Time (Change Booking)",
              eventProperties
            )
          } catch (err) {}

          onTimesChange(true)
        }
      }
    }

    function timeClear(retainTimes) {
      const timeButtons = document.getElementsByClassName("time-button")
      for (const tb of timeButtons) {
        tb.classList.remove("selected")
        tb.classList.remove("auto-selected")
        tb.classList.remove("disabled")
        util.removeButtonClassAndTooltip(tb, "no-avail-end-time")
        util.removeButtonClassAndTooltip(tb, "no-avail-start-time")
        tb.removeEventListener("mouseover", mouseoverSelectOtherTimes)
        tb.removeEventListener("mouseout", mouseoutSelectOtherTimes)
      }
      document.getElementById("time-modal-header").innerText =
        "Choose a start time"
      document.getElementById("time-modal-clear").style.display = "none"

      timeStatus = TIME_NONE

      // If end time was already selected, select start time
      if (
        document
          .getElementById("end-time-select")
          .classList.contains("highlighted")
      ) {
        document
          .getElementById("end-time-select")
          .classList.remove("highlighted")
        document
          .getElementById("start-time-select")
          .classList.add("highlighted")
      }

      if (!(retainTimes === true)) {
        startTime = undefined
        endTime = undefined

        let inputTextStartTime = document.getElementById(
          "input-text-start-time"
        )
        inputTextStartTime.innerText = "Choose time"
        inputTextStartTime.classList.remove("completed")
        let inputTextEndTime = document.getElementById("input-text-end-time")
        inputTextEndTime.innerText = "Choose time"
        inputTextEndTime.classList.remove("completed")
        try {
          document
            .getElementById("start-time-select")
            .classList.remove("highlighted")
        } catch (err) {}
        try {
          document
            .getElementById("end-time-select")
            .classList.remove("highlighted")
        } catch (err) {}
      }
    }

    function timeClose() {
      if (timeStatus === TIME_NONE) {
        try {
          document
            .getElementById("start-time-select")
            .classList.remove("highlighted")
        } catch (err) {}
      } else if (timeStatus === TIME_START) {
        if (endTime) {
          util.clickTime(endTime)
        } else {
          timeClear()
        }
      }
      document.querySelector(".time-modal").style.display = "none"

      try {
        const eventProperties = {
          "Selected Date": document.querySelector(".text-date-input-space")
            .value,
          "Start Time": startTime,
          "End Time": endTime,
        }
        util.logAmplitudeEvent(
          "Close Time Modal (Change Booking)",
          eventProperties
        )
      } catch (err) {}
    }

    // If just a start time is selected, as the user mouses over potential end times, colour all the times in between.
    function mouseoverSelectOtherTimes(e) {
      if (timeStatus === TIME_START) {
        let mouseoverTime = e.currentTarget.innerText
        const timeButtons = document.getElementsByClassName("time-button")
        for (const tb of timeButtons) {
          if (tb.innerText < mouseoverTime && tb.innerText > startTime) {
            tb.classList.add("auto-selected")
          }
        }
      }
    }

    function mouseoutSelectOtherTimes(e) {
      if (timeStatus === TIME_START) {
        let mouseoverTime = e.currentTarget.innerText
        const timeButtons = document.getElementsByClassName("time-button")
        for (const tb of timeButtons) {
          if (tb.innerText < mouseoverTime && tb.innerText > startTime) {
            tb.classList.remove("auto-selected")
          }
        }
      }
    }

    /**
     * When times change, check the pricing and update the checkout data.
     * This is called whenever the space, date or times are changed.
     *
     * @param {boolean} updateCheckoutData - whether checkout data should be
     * updated. This is normally true but not needed eg if the user changes the
     * email (price depends on email so we need to check that).
     */
    async function onTimesChange(updateCheckoutData) {
      // First reset everything
      let pricingElem = document.getElementById("booking-section-pricing")
      pricingElem.style.display = "none"
      let errorElem = document.getElementById("booking-section-error")
      errorElem.style.display = "none"

      let diff = getEndDateTime().diff(getStartDateTime())
      let numHours = parseInt(diff.as("hours"))
      let numMins = diff.as("minutes") - numHours * 60
      let numHoursFixed = util.roundToMaxDp(numHours + numMins / 60, 1)
      let hourText = "hours"
      if (numHours == 1 && numMins == 0) {
        hourText = "hour"
      }
      let inputTextStartTime = document.getElementById("input-text-start-time")
      inputTextStartTime.innerText = getStartTime()
      inputTextStartTime.classList.add("completed")
      let inputTextEndTime = document.getElementById("input-text-end-time")
      inputTextEndTime.innerText =
        getEndTime() + " (" + numHoursFixed + " " + hourText + ")"
      inputTextEndTime.classList.add("completed")

      let totalPrice
      if (
        document.getElementById("set-custom-times").checked ||
        util.checkTimesAreAvailable(
          getStartDateTime().ts,
          getEndDateTime().ts,
          availableTimes
        )
      ) {
        totalPrice = await findSpacePricing()
      }

      if (!totalPrice) {
        let mismatch = durationMismatch(numHours, numMins)
        if (mismatch && mismatch.type === "belowMinDuration") {
          errorElem.innerText = `The venue doesn't accept bookings below ${mismatch.duration} hours - please extend your selection.`
        } else if (mismatch && mismatch.type === "aboveMaxDuration") {
          errorElem.innerText = `The venue doesn't accept bookings over ${mismatch.duration} hours - please change your selection.`
        } else {
          errorElem.innerText =
            "There is no availability for your selected times - please choose a different time."
        }
        errorElem.style.display = "block"
        document.getElementById("preloader-background").classList.add("hide")
        totalPrice = session.price
      }
      const hourlyPrice = util.calculateHourlyPrice(
        totalPrice,
        numHours,
        numMins
      )
      document.getElementById("booking-section-price-detail").innerText =
        "£" + hourlyPrice + " x " + numHoursFixed + " " + hourText
      document.getElementById("booking-section-price-total").innerText =
        "£" + totalPrice
      updateBasketDisplay()

      // Set fields used by custom checkout
      checkoutNumHours = numHoursFixed
      checkoutTotalPrice = parseFloat(totalPrice)

      // Set the custom times
      if (!document.getElementById("set-custom-times").checked) {
        document.getElementById("custom-date").value = date
        document.getElementById("custom-start-time").value = startTime
        document.getElementById("custom-end-time").value = endTime
        customDate = date
        customStartTime = startTime
        customEndTime = endTime
      }
      updateCancelBy()
      if (updateCheckoutData) {
        await getCheckoutData()
        updateAddonsInBasket()
      }
    }

    function getStartDateTime() {
      return util.calculateDateTime(
        getDate(),
        getStartTime(),
        getStartTimeOnNextDay()
      )
    }

    function getEndDateTime() {
      return util.calculateDateTime(
        getDate(),
        getEndTime(),
        getEndTimeOnNextDay()
      )
    }

    function getDate() {
      let usingCustomTimes = document.getElementById("set-custom-times").checked
      if (usingCustomTimes) {
        return customDate
      }
      return date
    }

    function getStartTime() {
      let usingCustomTimes = document.getElementById("set-custom-times").checked
      if (usingCustomTimes) {
        return customStartTime
      }
      return startTime
    }

    function getStartTimeOnNextDay() {
      let usingCustomTimes = document.getElementById("set-custom-times").checked
      if (usingCustomTimes) {
        return false
      }
      return startTimeOnNextDay
    }

    function getEndTime() {
      let usingCustomTimes = document.getElementById("set-custom-times").checked
      if (usingCustomTimes) {
        return customEndTime
      }
      return endTime
    }

    function getEndTimeOnNextDay() {
      let usingCustomTimes = document.getElementById("set-custom-times").checked
      if (usingCustomTimes) {
        return customEndTime <= "06:00"
      }
      return endTimeOnNextDay
    }

    /**
     * New system pricing endpoint
     */
    async function findSpacePricing() {
      let booker_email =
        document.getElementById("email").value || session.booking.email
      let apply_preferred_booker_rate = session.apply_preferred_booker_rate
      const startTimestamp = getStartDateTime().ts / 1000
      const endTimestamp = getEndDateTime().ts / 1000
      const params = `?start_timestamp=${startTimestamp}&end_timestamp=${endTimestamp}&slug=${slug}&booker_email=${encodeURIComponent(
        booker_email
      )}&apply_preferred_booker_rate=${apply_preferred_booker_rate}`
      try {
        const data = await util.api.get(`get-session-price${params}`).json()
        return data.price
      } catch (error) {
        util.logToSentry(error)
        util.logAmplitudeEvent(
          "Unknown Error Retrieving Session Price (Change Booking)"
        )
      }
    }

    /* Check if the times match, but the minimum or maximum duration is not met */
    function durationMismatch(numHours, numMins) {
      if (date.length === 0 || !availableTimes) {
        return
      }
      const startTimestamp = getStartDateTime().ts
      const endTimestamp = getEndDateTime().ts
      const durationHours = numHours + numMins / 60
      let belowMinDuration = 0
      let aboveMaxDuration = 0
      let matchingTimes = availableTimes.filter(
        (t) =>
          t.start_time_utc <= startTimestamp && t.end_time_utc >= endTimestamp
      )
      let durationMatches = matchingTimes.filter(
        (t) => durationHours >= t.min_at_hours
      )
      if (durationMatches.length > 0) {
        return
      } else {
        durationMatches = matchingTimes.filter(
          (t) => durationHours < t.min_at_hours
        )
        if (durationMatches.length > 0) {
          // get min of all min_at_hours in durationMatches
          belowMinDuration = durationMatches.reduce(
            (min, t) => (t.min_at_hours < min ? t.min_at_hours : min),
            durationMatches[0].min_at_hours
          )
          return {
            type: "belowMinDuration",
            duration: belowMinDuration,
          }
        }
      }
    }

    function updateBasketDisplay() {
      document.getElementById("basket-date").innerText =
        document.getElementById("input-text-date").innerText
      document.getElementById("basket-time").innerText =
        getStartTime() + " - " + getEndTime()
      document.getElementById("basket-price-detail").innerText =
        document.getElementById("booking-section-price-detail").innerText
      document.getElementById("basket-price-total").innerText =
        document.getElementById("booking-section-price-total").innerText
    }

    function displayTimeModal(selectStartTime) {
      timeClear(true)
      setTimeAvailability()

      document.querySelector(".time-modal").style.display = "flex"
      document.getElementById("start-time-select").classList.add("highlighted")
      document.getElementById("end-time-select").classList.remove("highlighted")

      /* If the user has already chosen a start and end time, and they click on
      the end time, we assume they just want to change the end time so we
      reselect their start time first. */
      if (!selectStartTime && startTime && endTime) {
        util.clickTime(startTime)
      }
    }

    /**
     * On the space page this is called when the user reserves a time slot. For
     * changebooking this initialises the checkout fields.
     */
    async function displayCheckout() {
      let questionFormFieldIds = util.getQuestionIdsFromElements("question_id")
      let venueQuestionSection = document.getElementById("venue-questions")
      // Add venue-specific questions
      for (const question of checkoutData.questions) {
        if (!questionFormFieldIds.includes(question.id)) {
          let questionTextAndControl
          let isRequired = question.is_required
          if (isRequired && (await isDashboardPage(false))) {
            // Don't force venues or Sharesy CS to fill in previously unanswered questions
            isRequired = false
          }
          if (question.type === "checkbox") {
            questionTextAndControl = document.createElement("label")
            questionTextAndControl.classList.add("w-checkbox")
            questionTextAndControl.classList.add("checkbox-field")
            let questionInput = document.createElement("input")
            questionInput.type = "checkbox"
            questionInput.classList.add("w-checkbox-input")
            questionInput.classList.add("checkbox")
            questionInput.required = isRequired
            questionInput.setAttribute("question_id", question.id)
            questionInput.addEventListener("change", function (e) {
              checkForBookingChanges()
            })
            let questionLabel = document.createElement("span")
            questionLabel.classList.add("checkbox-label")
            questionLabel.classList.add("w-form-label")
            let questionHTML = question.question
            try {
              // We allow question text to include markdown - it is
              // parsed with marked then DOMPurify
              questionHTML = DOMPurify.sanitize(
                marked.parseInline(question.question)
              )
            } catch (err) {
              util.logToSentry(err)
            }
            questionLabel.innerHTML =
              questionHTML + (isRequired ? " <span class='red'>*</span>" : "")
            questionTextAndControl.appendChild(questionInput)
            questionTextAndControl.appendChild(questionLabel)
          } else {
            let questionControl
            if (question.type === "options") {
              questionControl = document.createElement("select")
              questionControl.setAttribute("question_id", question.id)
              questionControl.classList.add("select-default")
              questionControl.classList.add("w-select")
              questionControl.required = isRequired
              let option = document.createElement("option")
              option.value = ""
              option.disabled = true
              option.selected = true
              option.innerText = "Select an option..."
              questionControl.appendChild(option)
              question.options.forEach(function (option) {
                let optionElem = document.createElement("option")
                optionElem.value = option.option
                optionElem.innerText = option.option
                questionControl.appendChild(optionElem)
              })
            } else if (question.type === "text") {
              questionControl = document.createElement("textarea")
              questionControl.setAttribute("question_id", question.id)
              questionControl.classList.add("textarea-default")
              questionControl.classList.add("w-input")
              questionControl.required = isRequired
              questionControl.maxLength = 499
              if (question.placeholder) {
                questionControl.placeholder =
                  question.placeholder +
                  (question.is_required ? "" : " (optional)")
              }
            }
            questionControl.addEventListener("change", function (e) {
              checkForBookingChanges()
            })
            questionTextAndControl = document.createElement("div")
            questionTextAndControl.classList.add("text-and-input")
            let questionText = document.createElement("div")
            let questionHTML = question.question
            try {
              questionHTML = DOMPurify.sanitize(
                marked.parseInline(question.question)
              )
            } catch (err) {
              util.logToSentry(err)
            }
            questionText.innerHTML =
              questionHTML + (isRequired ? " <span class='red'>*</span>" : "")
            questionTextAndControl.appendChild(questionText)
            questionTextAndControl.appendChild(questionControl)
          }
          // Add as second last element
          venueQuestionSection.insertBefore(
            questionTextAndControl,
            venueQuestionSection.lastChild
          )
          venueQuestionSection.classList.remove("hide")
        }
      }

      let option
      let eventTypeSelect = document.getElementById("event-type")
      let eventTypeQuestions = checkoutData.questions.filter(
        (q) => q.id === parseInt(eventTypeSelect.getAttribute("question_id"))
      )
      if (eventTypeQuestions.length > 0) {
        let eventTypeOptions = eventTypeQuestions[0].options.map(
          (o) => o.option
        )
        option = document.createElement("option")
        option.value = ""
        option.disabled = true
        option.selected = true
        option.innerText = "Select an event type..."
        eventTypeSelect.appendChild(option)
        eventTypeOptions.forEach(function (eventType) {
          let option = document.createElement("option")
          option.value = eventType
          option.innerText = eventType
          eventTypeSelect.appendChild(option)
        })
      } else {
        // E.g. if there is a question_map_exclude for this space
        eventTypeSelect.removeAttribute("field_required")
        eventTypeSelect.parentElement.classList.add("hide")
      }
      let marketingChannelSelect = document.getElementById("marketing-channel")
      let marketingChannelQuestions = checkoutData.questions.filter(
        (q) =>
          q.id === parseInt(marketingChannelSelect.getAttribute("question_id"))
      )
      if (marketingChannelQuestions.length > 0) {
        let marketingChannelOptions = marketingChannelQuestions[0].options.map(
          (o) => o.option
        )
        option = document.createElement("option")
        option.value = ""
        option.disabled = true
        option.selected = true
        option.innerText = "Select an option..."
        marketingChannelSelect.appendChild(option)
        marketingChannelOptions.forEach(function (marketingChannel) {
          let option = document.createElement("option")
          option.value = marketingChannel
          option.innerText = marketingChannel
          marketingChannelSelect.appendChild(option)
        })
      } else {
        marketingChannelSelect.removeAttribute("field_required")
        marketingChannelSelect.parentElement.classList.add("hide")
      }
      let numGuestsInput = document.getElementById("num-guests")
      let numGuestsQuestion = checkoutData.questions.filter(
        (q) => q.id === parseInt(numGuestsInput.getAttribute("question_id"))
      )
      if (numGuestsQuestion.length == 0) {
        numGuestsInput.removeAttribute("field_required")
        numGuestsInput.parentElement.classList.add("hide")
      }

      // Set required on for all visible input and select elements within the form
      let checkoutFormInputs = document
        .getElementById("change-booking-form")
        .querySelectorAll("input, select, textarea")
      checkoutFormInputs.forEach(function (elem) {
        if (elem.classList.contains("hide")) {
          elem.classList.remove("hide")
          elem.type = "hidden"
        } else if (elem.hasAttribute("field_required")) {
          elem.required = true
        }
      })

      updateFromSession()
      updateBasketDisplay()

      let params = util.getSearchParams()
      // Special mode to allow admins to approve changes directly via a URL
      // with a "changes" param. This is no longer used now that bookers
      // and venues can make changes without needing CS approval.
      if (params.has("changes") && (await isDashboardPage(true))) {
        let changes = JSON.parse(params.get("changes"))
        let changeButton = document.getElementById("change-button")
        util.deleteUrlParam("changes")
        changeSession(
          params.get("id"),
          changes,
          changeButton,
          changeButton.value,
          true
        )
      }
    }

    /**
     * Update the checkout data and refresh the addons. This is called whenever
     * the space, date or times are changed.
     */
    async function getCheckoutData() {
      let startDateTime = getStartDateTime()
      let endDateTime = getEndDateTime()
      let ignoreAddonAvailability = false
      if (document.getElementById("set-custom-times").checked) {
        ignoreAddonAvailability = true
      }
      try {
        const data = await util.api
          .post("checkout-data", {
            json: {
              space_slug: slug,
              using_new_system: true,
              start_time: startDateTime,
              end_time: endDateTime,
              exclude_encrypted_trans_id_str: searchParams.get("id"),
              ignore_addon_availability: ignoreAddonAvailability,
            },
          })
          .json()
        checkoutData = data.checkout_data
        availableAddons = checkoutData.addons
        // Remove any of the selectedAddons that are no longer available,
        // and update the price eg if the duration has changed.
        let selectedAvailableAddons = availableAddons.filter((a) => {
          return selectedAddons.some((sa) => sa.addon_id === a.id)
        })
        selectedAddons = selectedAvailableAddons.map((a) => {
          let addonPrice = parseFloat(a.price)
          if (a.is_hourly_price) {
            addonPrice = addonPrice * checkoutNumHours
          }
          return {
            addon_id: a.id,
            name: a.name,
            price: util.roundToMaxDp(addonPrice, 2),
          }
        })
        displayAddons()
      } catch (error) {
        util.logToSentry(error)
        util.logAmplitudeEvent(
          "Unknown Error Calling checkout-data (Change Booking)"
        )
      }
    }

    async function updateFromSession() {
      selectedAddons = session.addons.map((a) => {
        return {
          addon_id: a.addon_id,
          name: a.name,
          price: a.total_price,
        }
      })
      displayAddons()
      updateAddonsInBasket()

      document.getElementById("first-name").value = session.booking.first_name
      document.getElementById("last-name").value = session.booking.last_name
      document.getElementById("email").value = session.booking.email
      document.getElementById("phone").value = session.booking.phone
      session.booking.questions.forEach(function (question) {
        let questionElem = document.querySelector(
          "[question_id='" + question.question_id + "']"
        )
        if (questionElem) {
          if (
            questionElem.type === "checkbox" &&
            util.valueToBool(question.answer)
          ) {
            questionElem.checked = true
          } else if (questionElem.type === "radio") {
            let radioElem = document.querySelector(
              "[question_id='" +
                question.question_id +
                "'][value='" +
                question.answer.toLowerCase() +
                "']"
            )
            if (radioElem) {
              radioElem.checked = true
            }
          } else {
            questionElem.value = question.answer
          }
        }
      })
      if (session.status_code == "cancelled") {
        showError("This booking is cancelled - it's not possible to change it.")
      }

      // Don't let bookers reschedule bookings after the reschedule_by date
      if (
        DateTime.now() > DateTime.fromISO(session.reschedule_by) &&
        !(await isDashboardPage(false))
      ) {
        showError("It is too late to change this booking.")
      }
      document.getElementById("preloader-background").classList.add("hide")
    }

    /**
     * Set selectedAddons to the addons currently checked.
     */
    async function updateSelectedAddons() {
      let checkedAddons = []
      document
        .getElementById("add-on-items")
        .querySelectorAll("input[type=checkbox]:checked")
        .forEach(function (checkedAddon) {
          let addonItem = checkedAddon.parentElement.parentElement
          let addonTextDivs = addonItem
            .getElementsByClassName("checkbox-item-text")[0]
            .querySelectorAll("div")
          checkedAddons.push({
            addon_id: parseInt(checkedAddon.getAttribute("addon_id")),
            name: addonTextDivs[0].innerText,
            price: addonTextDivs[1].dataset.price,
          })
        })
      selectedAddons = checkedAddons
      updateAddonsInBasket()
    }

    function selectAddonCheckboxes() {
      selectedAddons.forEach(function (addon) {
        let addonItem = document
          .getElementById("add-on-items")
          .querySelector("input[addon_id='" + addon.addon_id + "']")
        if (addonItem) {
          addonItem.checked = true
        }
      })
    }

    /**
     * Update the addons in the basket (the right side of the page on desktop)
     */
    function updateAddonsInBasket() {
      let grandTotal = checkoutTotalPrice
      let basketAddons = document.getElementById("basket-addons")
      basketAddons
        .querySelectorAll(".flex-between-10gap")
        .forEach(function (e) {
          basketAddons.removeChild(e)
        })
      for (const addon of selectedAddons) {
        grandTotal += parseFloat(addon.price)
        const newAddonDiv = document.createElement("div")
        basketAddons.insertBefore(newAddonDiv, basketAddons.lastChild)
        newAddonDiv.classList.add("flex-between-10gap")
        const addonNameDiv = document.createElement("div")
        newAddonDiv.appendChild(addonNameDiv)
        addonNameDiv.innerText = addon.name
        const addonPriceDiv = document.createElement("div")
        newAddonDiv.appendChild(addonPriceDiv)
        addonPriceDiv.innerText = "£" + parseFloat(addon.price).toFixed(2)
      }
      document.getElementById("basket-grand-total").innerText =
        "£" + parseFloat(grandTotal).toFixed(2)
      if (session.booking.promo_code) {
        let discount = 0
        if (session.coupon.percent_off) {
          discount = (grandTotal * session.coupon.percent_off) / 100
        } else if (session.coupon.amount_off) {
          discount = session.coupon.amount_off
        }
        document.getElementById("basket-discount").innerText =
          "-£" + discount.toFixed(2)
        document.getElementById("basket-total-charge").innerText =
          "£" + (grandTotal - discount).toFixed(2)
        document.getElementById("discount-row").classList.remove("hide")
        document.getElementById("total-paid-row").classList.remove("hide")
      } else {
        document.getElementById("basket-total-charge").innerText =
          document.getElementById("basket-grand-total").innerText
      }
      basketAddons.classList.remove("hide")
      checkForBookingChanges()
    }

    /**
     * Re-add the available addons to the page.
     */
    function displayAddons() {
      let divAddonItems = document.getElementById("add-on-items")
      // Remove any existing addons (happens on mobile if addons were shown then modal closed)
      while (divAddonItems.childNodes.length > 1) {
        divAddonItems.removeChild(divAddonItems.lastChild)
      }
      let divAddonItem = document.getElementsByClassName(
        "add-on-item-change-booking"
      )[0]
      document.getElementById("addon-section").classList.add("hide")
      availableAddons.forEach(function (addon) {
        document.getElementById("addon-section").classList.remove("hide")
        let newAddon = divAddonItem.cloneNode(true)
        newAddon.querySelector("input").setAttribute("addon_id", addon.id)
        let addonTextDivs = newAddon
          .getElementsByClassName("checkbox-item-text")[0]
          .querySelectorAll("div")
        addonTextDivs[0].innerText = addon.name
        let addonPrice = parseFloat(addon.price)
        if (addon.is_hourly_price) {
          addonPrice = addonPrice * checkoutNumHours
        }
        addonPrice = addonPrice.toFixed(2)
        addonTextDivs[1].innerText = "£" + addonPrice
        addonTextDivs[1].dataset.price = addonPrice
        newAddon.querySelector("input").addEventListener("change", function () {
          updateSelectedAddons()
          if (this.checked) {
            util.logAmplitudeEvent("Addon Selected (Change Booking)", {
              "Addon ID": addon.id,
              "Addon Name": addon.name,
              "Addon Price": addonPrice,
            })
          } else {
            util.logAmplitudeEvent("Addon Unselected (Change Booking)", {
              "Addon ID": addon.id,
              "Addon Name": addon.name,
              "Addon Price": addonPrice,
            })
          }
        })
        newAddon.classList.remove("hide")
        divAddonItems.appendChild(newAddon)
      })
      // Select any addons that were previously selected
      selectAddonCheckboxes()
    }

    function moveMobileOnlySections(event) {
      let basket = document.getElementById("basket")
      if (event.matches) {
        // The window is now <= TABLET_MAX_WIDTH
        let mobileBasketContainer = document.getElementById(
          "mobile-basket-container"
        )
        mobileBasketContainer.appendChild(basket)
      } else {
        // The window is now > TABLET_MAX_WIDTH
        document.getElementById("change-booking-form").appendChild(basket)
      }
    }

    async function checkForBookingChanges() {
      let changesSection = document.getElementById("changes-section")
      changesSection.classList.add("hide")
      let explainer = document.getElementById("change-explainer")
      explainer.innerText = "There is no cost to make this change"
      document.getElementById("price-change-section").classList.add("hide")

      if (!document.getElementById("email").value) {
        return
      }

      changesToSend = []
      changesToDisplay = []

      let oldSlug = session.space_slug
      if (oldSlug !== slug) {
        const spaceSelect = document.getElementById("space")
        changesToDisplay.push({
          type: "session",
          field: "Space",
          old: session.space_name,
          new: spaceSelect.options[spaceSelect.selectedIndex].text,
        })
        changesToSend.push({
          type: "session",
          field: "space_slug",
          old: oldSlug,
          new: slug,
        })
      }

      let oldStartDateTime = DateTime.fromISO(session.event_start_utc).setZone(
        util.TIMEZONE
      )
      let newStartDateTime = getStartDateTime()
      let oldEndDateTime = DateTime.fromISO(session.event_end_utc).setZone(
        util.TIMEZONE
      )
      let newEndDateTime = getEndDateTime()
      if (newEndDateTime <= newStartDateTime) {
        return
      }
      let oldPayLaterDateTime = DateTime.fromISO(
        session.booking.delayed_payment_utc
      ).setZone(util.TIMEZONE)
      if (
        oldStartDateTime.toISO() !== newStartDateTime.toISO() ||
        oldEndDateTime.toISO() !== newEndDateTime.toISO()
      ) {
        changesToDisplay.push({
          type: "session",
          field: "Session times",
          old:
            oldStartDateTime.toFormat("ccc dd LLL yyyy HH:mm") +
            "-" +
            oldEndDateTime.toFormat("HH:mm"),
          new:
            newStartDateTime.toFormat("ccc dd LLL yyyy HH:mm") +
            "-" +
            newEndDateTime.toFormat("HH:mm"),
        })
        changesToSend.push({
          type: "session",
          field: "event_times",
          old: {
            start: oldStartDateTime.toISO(),
            end: oldEndDateTime.toISO(),
          },
          new: {
            start: newStartDateTime.toISO(),
            end: newEndDateTime.toISO(),
          },
        })
        if (
          oldStartDateTime.toISO() !== newStartDateTime.toISO() &&
          session.booking.payment_method_code === "delayed_payment"
        ) {
          if (
            oldPayLaterDateTime.toISO() > DateTime.now().toISO() &&
            oldPayLaterDateTime.toISO() !== payLaterDateTime.toISO()
          ) {
            changesToDisplay.push({
              type: "session",
              field: "Payment will be collected",
              old: oldPayLaterDateTime.toFormat("ccc dd LLL yyyy HH:mm"),
              new: payLaterDateTime.toFormat("ccc dd LLL yyyy HH:mm"),
            })
            // Just inform the user of the change, but no need to add it
            // to changesToSend.
          }
        }
      }

      let oldAddons = session.addons
      let newAddons = selectedAddons
      let oldAddonIds = oldAddons.map((a) => a.addon_id)
      let newAddonIds = newAddons.map((a) => a.addon_id)
      let removedAddonIds = oldAddonIds.filter((a) => !newAddonIds.includes(a))
      let addedAddonIds = newAddonIds.filter((a) => !oldAddonIds.includes(a))
      if (removedAddonIds.length > 0 || addedAddonIds.length > 0) {
        changesToDisplay.push({
          type: "session",
          field: "Add-ons",
          old: oldAddons.map((a) => a.name).join(", "),
          new: newAddons.map((a) => a.name).join(", "),
        })
        changesToSend.push({
          type: "session",
          field: "addon_ids",
          old: oldAddonIds,
          new: newAddonIds,
        })
      }

      document.getElementById("price-change-checkbox").required = false
      document.getElementById("payment-yes").required = false
      document.getElementById("payment-no").required = false
      let newPrice = parseFloat(
        document
          .getElementById("basket-total-charge")
          .innerText.replace("£", "")
      )
      let priceDifference = newPrice - parseFloat(session.total_price)
      if (Math.abs(priceDifference) > 0.01) {
        changesToDisplay.push({
          type: "session",
          field: session.booking.promo_code
            ? "Price (after promo code)"
            : "Price",
          new: "£" + newPrice.toFixed(2),
          old: "£" + parseFloat(session.total_price).toFixed(2),
        })
        changesToSend.push({
          type: "session",
          field: "total_price",
          old: parseFloat(session.total_price),
          new: newPrice,
        })
        if (priceDifference > 0) {
          document.getElementById("price-change-message").innerText =
            "An extra £" +
            priceDifference.toFixed(2) +
            " will be charged to the original payment method"
          if (
            session.booking.payment_method_code === "delayed_payment" &&
            oldPayLaterDateTime.toISO() > DateTime.now().toISO()
          ) {
            document.getElementById("price-change-message").innerText +=
              " when payment is collected later."
          }
          if (await isDashboardPage(false)) {
            if (
              session.booking.payment_method_code === "delayed_payment" &&
              oldPayLaterDateTime.toISO() > DateTime.now().toISO()
            ) {
              document.getElementById(
                "price-change-checkbox-label"
              ).innerHTML = `I understand the booker will be charged extra <span class="red">*</span>`
            } else {
              document.getElementById(
                "price-change-checkbox-label"
              ).innerHTML = `I understand the booker will be charged extra <span class="red">*</span>`
            }
          } else {
            if (
              session.booking.payment_method_code === "delayed_payment" &&
              oldPayLaterDateTime.toISO() > DateTime.now().toISO()
            ) {
              document.getElementById(
                "price-change-checkbox-label"
              ).innerHTML = `I accept the price increase <span class="red">*</span>`
            } else {
              document.getElementById(
                "price-change-checkbox-label"
              ).innerHTML = `I accept the price increase <span class="red">*</span>`
            }
          }
        } else {
          document.getElementById("price-change-message").innerText =
            "The difference of £" +
            Math.abs(priceDifference).toFixed(2) +
            " will be refunded from the original payment method"
          if (
            session.booking.payment_method_code === "delayed_payment" &&
            oldPayLaterDateTime.toISO() > DateTime.now().toISO()
          ) {
            document.getElementById("price-change-message").innerText +=
              " when payment is collected later."
          }
          document.getElementById(
            "price-change-checkbox-label"
          ).innerHTML = `I accept the price change <span class="red">*</span>`
        }
        explainer.innerText = ""
        if (await isDashboardPage(true)) {
          if (
            session.booking.payment_method_code !== "delayed_payment" ||
            oldPayLaterDateTime.toISO() < DateTime.now().toISO()
          ) {
            document.getElementById("payment-radios").classList.remove("hide")
            document.getElementById("payment-yes").required = true
            document.getElementById("payment-no").required = true
          } else {
            // An admin user is changing a session with a future delayed
            // payment: no need to show a checkbox or radios.
          }
        } else {
          document
            .getElementById("price-change-checkbox-field")
            .classList.remove("hide")
          document.getElementById("price-change-checkbox").required = true
        }
        document.getElementById("price-change-section").classList.remove("hide")
      }

      let oldEmail = session.booking.email
      let newEmail = document.getElementById("email").value
      let oldPhone = session.booking.phone
      let newPhone = document.getElementById("phone").value
      let oldFirstName = session.booking.first_name
      let newFirstName = document.getElementById("first-name").value
      let oldLastName = session.booking.last_name
      let newLastName = document.getElementById("last-name").value
      if (oldFirstName !== newFirstName) {
        changesToDisplay.push({
          type: "booker",
          field: "First name",
          new: newFirstName,
          old: oldFirstName,
        })
        changesToSend.push({
          type: "booker",
          field: "first_name",
          old: oldFirstName,
          new: newFirstName,
        })
      }
      if (oldLastName !== newLastName) {
        changesToDisplay.push({
          type: "booker",
          field: "Last name",
          new: newLastName,
          old: oldLastName,
        })
        changesToSend.push({
          type: "booker",
          field: "last_name",
          old: oldLastName,
          new: newLastName,
        })
      }
      if (oldEmail !== newEmail) {
        changesToDisplay.push({
          type: "booker",
          field: "Email",
          new: newEmail,
          old: oldEmail,
        })
        changesToSend.push({
          type: "booker",
          field: "email",
          old: oldEmail,
          new: newEmail,
        })
      }
      if (oldPhone !== newPhone) {
        changesToDisplay.push({
          type: "booker",
          field: "Phone",
          new: newPhone,
          old: oldPhone,
        })
        changesToSend.push({
          type: "booker",
          field: "phone",
          old: oldPhone,
          new: newPhone,
        })
      }

      let oldQuestions = session.booking.questions
      let newQuestions = []
      document.querySelectorAll("[question_id]").forEach((questionElem) => {
        let question = {
          id: parseInt(questionElem.getAttribute("question_id")),
        }
        if (questionElem.type === "checkbox") {
          question.answer = questionElem.checked ? true : false
          question.type = "checkbox"
        } else if (questionElem.type === "radio") {
          if (questionElem.checked) {
            question.answer = questionElem.value
            question.type = "radio"
          }
        } else {
          question.answer = questionElem.value
        }
        // Only add if there is an answer and if the id hasn't already been added (radios have multiple inputs with same id)
        if (
          !question.answer ||
          newQuestions.find((q) => q.id === question.id)
        ) {
          return
        }
        let oldQuestion = oldQuestions.find(
          (q) => q.question_id === question.id
        )
        if (
          !oldQuestion ||
          oldQuestion.answer.toString().toUpperCase() !==
            question.answer.toString().toUpperCase()
        ) {
          let oldAnswer = null
          if (oldQuestion) {
            oldAnswer = oldQuestion.answer
          }
          let questionText = ""
          if (question.type === "checkbox") {
            questionText = questionElem.parentElement.lastChild.innerText
          } else if (question.type === "radio") {
            questionText =
              questionElem.parentElement.parentElement.parentElement.firstChild
                .innerText
          } else {
            questionText = questionElem.parentElement.firstChild.innerText
          }
          changesToDisplay.push({
            type: "question",
            field: questionText,
            new: question.answer,
            old: oldAnswer,
          })
          changesToSend.push({
            type: "question",
            field: question.id,
            old: oldAnswer,
            new: question.answer,
          })
        }
      })

      if (changesToDisplay.length > 0) {
        let sessionChangesSection = document.getElementById("session-changes")
        let bookerChangesSection = document.getElementById("booker-changes")
        let questionChangesSection = document.getElementById("question-changes")
        sessionChangesSection.classList.add("hide")
        bookerChangesSection.classList.add("hide")
        questionChangesSection.classList.add("hide")

        let sessionChanges = changesToDisplay.filter(
          (c) => c.type === "session"
        )
        let bookerChanges = changesToDisplay.filter((c) => c.type === "booker")
        let questionChanges = changesToDisplay.filter(
          (c) => c.type === "question"
        )
        addChanges(sessionChangesSection, sessionChanges)
        addChanges(bookerChangesSection, bookerChanges)
        addChanges(questionChangesSection, questionChanges)
        changesSection.classList.remove("hide")
      }
    }

    function addChanges(section, changes) {
      if (changes.length > 0) {
        section.classList.remove("hide")
        // Leave the first title div
        while (section.childNodes.length > 1) {
          section.removeChild(section.lastChild)
        }
        changes.forEach((c) => {
          let changeDiv = document.createElement("div")
          section.appendChild(changeDiv)
          changeDiv.classList.add("change")
          let titleDiv = document.createElement("div")
          changeDiv.appendChild(titleDiv)
          titleDiv.classList.add("text-10px-upper")
          titleDiv.innerText = c.field
          let oldDiv = document.createElement("div")
          changeDiv.appendChild(oldDiv)
          oldDiv.classList.add("strikethrough")
          oldDiv.innerText = c.old
          let newDiv = document.createElement("div")
          changeDiv.appendChild(newDiv)
          newDiv.innerText = c.new
        })
      }
    }

    function displayChangeBookingError(message) {
      document.getElementById("unavailable-error").innerText = message
      let checkoutError = document.getElementById("checkout-error")
      checkoutError.style.display = "flex"
      checkoutError.scrollIntoView({
        block: "center",
        behavior: "smooth",
      })
    }

    async function changeSession(
      id,
      changes,
      changeButton,
      changeButtonText,
      isAutoChange
    ) {
      let jsonBody = {
        id: id,
        changes: changes,
        process_payment: true,
        check_availability:
          !document.getElementById("set-custom-times").checked,
      }
      let paymentRadioChecked = document.querySelector(
        'input[name="payment"]:checked'
      )
      if (paymentRadioChecked && paymentRadioChecked.value == "no") {
        jsonBody.process_payment = false
      }

      if (await isDashboardPage(false)) {
        // If user is accessing the dashboard page, make sure they are authenticated
        jsonBody.token = await utillogin.getClerkToken()
      }
      try {
        const data = await util.api
          .post("change-session", {
            json: jsonBody,
            retry: { limit: 0 },
          })
          .json()
        if (data.success) {
          changeButton.value = changeButtonText
          changeButton.disabled = false
          getSessionAndAvailabilityData()
          await Swal.fire({
            icon: "success",
            text: "The booking has been updated. You can close this tab, or refresh to make further changes.",
            confirmButtonText: "Refresh",
            confirmButtonColor: "#1aa979",
            customClass: {
              popup: "swal-custom-popup",
              title: "swal-custom-title",
              confirmButton: "swal-custom-button",
            },
            allowOutsideClick: false,
          })
          window.location.reload()
        } else {
          displayChangeBookingError(
            data.reason
              ? data.reason
              : "An error has occurred while trying to proceed. Please refresh and try again, and if the problem continues email help@sharesy.com and we'll manually change the booking for you."
          )
        }
      } catch (error) {
        util.logToSentry(error)
        displayChangeBookingError(
          "An error has occurred while trying to proceed. Please refresh and try again, and if the problem continues email help@sharesy.com and we'll manually change the booking for you."
        )
      }
    }

    async function setupCustomTimes() {
      if (await isDashboardPage(false)) {
        document
          .getElementById("set-custom-times-section")
          .classList.remove("hide")
        document
          .getElementById("set-custom-times")
          .addEventListener("change", function (e) {
            if (e.currentTarget.checked) {
              document.getElementById("custom-times").classList.remove("hide")
              document
                .getElementById("booking-section-inner")
                .classList.add("hide")
            } else {
              document.getElementById("custom-times").classList.add("hide")
              document
                .getElementById("booking-section-inner")
                .classList.remove("hide")
            }
            document.getElementById("custom-date").required =
              e.currentTarget.checked
            document.getElementById("custom-start-time").required =
              e.currentTarget.checked
            document.getElementById("custom-end-time").required =
              e.currentTarget.checked
            onTimesChange(true)
            checkForBookingChanges()
          })
        document
          .getElementById("custom-date")
          .addEventListener("change", (e) => {
            customDate = e.target.value
            onTimesChange(true)
            checkForBookingChanges()
          })
        document
          .getElementById("custom-start-time")
          .addEventListener("change", (e) => {
            customStartTime = e.target.value
            onTimesChange(true)
            checkForBookingChanges()
          })
        document
          .getElementById("custom-end-time")
          .addEventListener("change", (e) => {
            customEndTime = e.target.value
            onTimesChange(true)
            checkForBookingChanges()
          })
      }
    }

    function init() {
      try {
        // Add a DOMPurify hook to open all links in a new tab
        DOMPurify.addHook("afterSanitizeAttributes", function (node) {
          if ("target" in node) {
            node.setAttribute("target", "_blank")
            // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
            node.setAttribute("rel", "noopener noreferrer")
            return node
          }
        })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        initClerk()
      } catch (err) {}

      // I couldn't move the image slider with CSS alone so used this instead
      try {
        const mediaQueryList = window.matchMedia(
          "(max-width: " + util.TABLET_MAX_WIDTH + "px)"
        )
        try {
          mediaQueryList.addEventListener("change", moveMobileOnlySections)
        } catch (err) {
          // Safari before version 14
          mediaQueryList.addListener(moveMobileOnlySections)
        }
        // Need to call once on page load
        moveMobileOnlySections(mediaQueryList)
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("change-button")
          .addEventListener("click", async function (e) {
            e.preventDefault()
            let checkoutForm = document.getElementById("change-booking-form")
            if (!checkoutForm.checkValidity()) {
              checkoutForm.reportValidity()
              util.logAmplitudeEvent("Checkout Form Invalid (Change Booking)")
              return
            }
            // Only block form submission if the form is valid (so HTML5 validation errors will still be shown)
            let changeButton = document.getElementById("change-button")
            let changeButtonText = changeButton.value
            document.getElementById("checkout-error").style.display = "none"
            changeButton.value = "Please wait..."
            changeButton.disabled = true

            let changes = {}
            let spaceChange = changesToSend.find(
              (c) => c.field === "space_slug"
            )
            if (spaceChange) {
              changes.space_slug = {
                new: spaceChange.new,
                old: spaceChange.old,
              }
            }
            let eventTimesChange = changesToSend.find(
              (c) => c.field === "event_times"
            )
            if (eventTimesChange) {
              changes.event_times = {
                new: eventTimesChange.new,
                old: eventTimesChange.old,
              }
            }
            let addonIdsChange = changesToSend.find(
              (c) => c.field === "addon_ids"
            )
            if (addonIdsChange) {
              changes.addon_ids = {
                new: addonIdsChange.new,
                old: addonIdsChange.old,
              }
            }
            let totalPriceChange = changesToSend.find(
              (c) => c.field === "total_price"
            )
            if (Object.keys(changes).length === 0 && totalPriceChange) {
              changes.total_price = {
                new: totalPriceChange.new,
                old: totalPriceChange.old,
              }
            }
            let bookerChanges = changesToSend.filter((c) => c.type === "booker")
            if (bookerChanges.length > 0) {
              changes.booker = []
              bookerChanges.forEach((c) => {
                changes.booker.push({
                  field: c.field,
                  new: c.new,
                  old: c.old,
                })
              })
            }
            let questionChanges = changesToSend.filter(
              (c) => c.type === "question"
            )
            if (questionChanges.length > 0) {
              changes.questions = []
              questionChanges.forEach((c) => {
                changes.questions.push({
                  question_id: c.field,
                  new: c.new,
                  old: c.old,
                })
              })
            }
            await changeSession(
              searchParams.get("id"),
              changes,
              changeButton,
              changeButtonText,
              false
            )
          })
      } catch (err) {
        util.logToSentry(err)
      }

      // Add listeners to all the inputs
      try {
        // When someone selects the Other option in the event type dropdown, show the other event type field
        document
          .getElementById("event-type")
          .addEventListener("change", function (e) {
            let selectedEventType =
              e.target.options[e.target.selectedIndex].value
            let eventTypeOther = document.getElementById("event-type-other")
            if (selectedEventType === "Other") {
              eventTypeOther.type = "text"
              eventTypeOther.required = true
            } else {
              eventTypeOther.type = "hidden"
              eventTypeOther.required = false
              eventTypeOther.innerText = ""
            }
            checkForBookingChanges()
            util.logAmplitudeEvent("Event Type Selected (Change Booking)", {
              "Event Type": selectedEventType,
            })
          })
        document
          .getElementById("event-type-other")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
            util.logAmplitudeEvent(
              "Event Type Other Input Changed (Change Booking)",
              {
                "Input Value": this.value,
              }
            )
          })
        document
          .getElementById("num-guests")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
            util.logAmplitudeEvent(
              "Number of People Input Changed (Change Booking)",
              {
                "Input Value": this.value,
              }
            )
          })
        document
          .getElementById("furniture-equipment")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
            util.logAmplitudeEvent(
              "Furniture and Equipment Input Changed (Change Booking)",
              {
                "Input Value": this.value,
              }
            )
          })
        document
          .getElementById("anything-else")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
          })
        if (document.querySelector('input[name="alcohol"]')) {
          document.querySelectorAll('input[name="alcohol"]').forEach((elem) => {
            elem.addEventListener("change", function (event) {
              checkForBookingChanges()
              util.logAmplitudeEvent(
                "Alcohol Selection Changed (Change Booking)",
                {
                  "Input Value": event.target.value,
                }
              )
            })
          })
        }
        document
          .getElementById("first-name")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
            util.logAmplitudeEvent("First Name Input Changed (Change Booking)")
          })
        document
          .getElementById("last-name")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
            util.logAmplitudeEvent("Last Name Input Changed (Change Booking)")
          })
        document
          .getElementById("email")
          .addEventListener("change", async function (e) {
            // The price depends on email so we need to update pricing
            await onTimesChange(false)
            checkForBookingChanges()
          })
        document
          .getElementById("phone")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
          })
        document
          .getElementById("marketing-channel")
          .addEventListener("change", function (e) {
            checkForBookingChanges()
            let selectedMarketingChannel =
              e.target.options[e.target.selectedIndex].value
            util.logAmplitudeEvent(
              "Marketing Channel Selected (Change Booking)",
              {
                "Marketing Channel": selectedMarketingChannel,
              }
            )
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        setupCustomTimes()
      } catch (err) {
        util.logToSentry(err)
      }
    }

    return {
      init: init,
    }
  })()
}
